/**
 * Component: Model landing filter
 * ------------------------------------------------------------------------------
 * Automatically apply all years filter when clicking featured collection with
 * no current car set.
 *
 * @namespace modelLandingFilter
 */
import log from 'salvo-lite/log'
import {on} from '../helpers/utils'

class ModelLanding {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem

        this._settings = {
            featuredCollectionLink: '[js-featured-collection="link"]',
            ...JSON.parse(elem.getAttribute('data-model-landing') || '{}')
        }

        /**
         * DOM node selectors.
         */
        this._nodeSelectors = {
            featuredCollectionLink: [...document.querySelectorAll(this._settings.featuredCollectionLink)]
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        this._setEventListeners()
    }

    /**
     * Set event listeners.
     */
    _setEventListeners () {
        this._nodeSelectors.featuredCollectionLink.forEach((element) => {
            on('click', element, (event) => this._handleCollectionClick(event))
        })
    }

    /**
     * Handle the featured collection click.
     * @param {Object} event - The click event.
     */
    _handleCollectionClick (event) {
        if (window.Frame.CurrentCarCookie.isCookieSet() || !window.modelYear) {
            return
        }

        event.preventDefault()
        const clickUrl = event.target.closest(this._settings.featuredCollectionLink).getAttribute('href')

        const url = `${window.location.origin}${clickUrl}`

        /**
         * Set listener for CurrentCar update.
         */
        window.Frame.EventBus.listen('CurrentCar:updated', () => {
            window.location.href = url
        })

        /**
         * Update CurrentCar.
         */
        window.Frame.EventBus.emit('CurrentCar:setCar', window.modelYear)
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // })
}

export default ModelLanding



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ModelLanding.js